import styled from 'styled-components';
import { Icon } from '@appcues/sonar';

export const PropertyItem = styled.li`
  min-height: 45px;
  list-style: none;
  display: flex;
  align-items: center;
  background-color: var(--color-neutral-50);
  border-radius: 6px;
  padding: 0 var(--spacing-regular);
  justify-content: space-between;
  cursor: pointer;
`;

export const PropertiesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small, 4px);
  margin-top: 8px;
`;

export const PropertyName = styled.span`
  display: flex;
  gap: 24px;
  align-items: center;
  padding: var(--spacing-small) 0;
  overflow: hidden;
  ${Icon} {
    font-size: 16px;
    color: var(--sharkbait-ooh-la-la);
  }
`;
